import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=e0ab63ea&scoped=true&"
import script from "./Entrance.vue?vue&type=script&lang=ts&"
export * from "./Entrance.vue?vue&type=script&lang=ts&"
import style0 from "./Entrance.vue?vue&type=style&index=0&id=e0ab63ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ab63ea",
  null
  
)

export default component.exports